import { Spin } from 'antd'
import React from 'react'
import { LoadingOutlined } from '@ant-design/icons';

type LoaderType = {
    size?: number
}

const Loader = ({size = 24}: LoaderType) => {
    return (
            <Spin indicator={<LoadingOutlined style={{ fontSize: size }} spin />} />
    )
}

export default Loader